import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import TextButton from 'components/Luxkit/Button/TextButton'
import LineMapIcon from 'components/Luxkit/Icons/line/LineMapIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { Place } from 'tripPlanner/types/common'
import { googleMapsQueryUrl } from 'tripPlanner/utils'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`

const Address = styled.div`
  display: flex;
  flex-direction: column;
`

const Actions = styled.div`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.five};
  margin-top: 16px;
  width: fit-content;
`

type Props = {
  place: Place
}

function LocationWithMap({ place }: Props) {
  return (
    <Wrapper>
      <BodyText variant="medium" weight="semi-bold">
        Location
      </BodyText>
      <Address>
        <BodyText variant="large">{place.name}</BodyText>
        <BodyText variant="large">{place.address}</BodyText>
      </Address>
      <Actions>
        {place.address && (
          <TextButton
            kind="secondary"
            startIcon={<LineMapIcon colour="primary" />}
            target="_blank"
            href={googleMapsQueryUrl(place.address)}
          >
            View on Google Maps
          </TextButton>
        )}
      </Actions>
    </Wrapper>
  )
}
export default LocationWithMap
